module.exports = __webpack_public_path__ + "static/img/map_bg.210d1c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/map_bg.jpg
// module id = jWO/
// module chunks = 200